/** Sent/received instants are stored as UTC ISO. Always label that zone. */
export const MARKETPLACE_SENT_TIME_ZONE = "UTC";

const COLUMN_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
  hour: "numeric",
  minute: "2-digit",
  timeZone: MARKETPLACE_SENT_TIME_ZONE,
  timeZoneName: "short",
};

const ABSOLUTE_OPTIONS: Intl.DateTimeFormatOptions = {
  ...COLUMN_OPTIONS,
  year: "numeric",
};

export function formatMarketplaceSentColumn(
  iso: string,
  locale: string,
): string {
  return new Intl.DateTimeFormat(locale, COLUMN_OPTIONS).format(new Date(iso));
}

export function formatMarketplaceSentAt(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, ABSOLUTE_OPTIONS).format(new Date(iso));
}
